import OnboardingStoryboard from './components/shop-steps'

export default function ShopSignUp() {
  // Manually parse the "step" parameter from the URL
  const queryParams = new URLSearchParams(window.location.search)
  const stepParam = queryParams.get('step') // Get the "step" parameter
  const initialStep = stepParam ? parseInt(stepParam, 10) : 0 // Parse the step or default to 0

  return <OnboardingStoryboard initialStep={initialStep} />
}
